/**
 * @desc pageListStockOrder
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(params: API.stock.stockOrder.pageListStockOrder.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/order/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
